export const defaultColor = '#D4D4C8';
export const signColor = '#808080';
export const elementColor = '#569CD6';
export const attributeNameColor = '#9CDCFD';
export const attributeValueColor = '#CE9178';
